import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { IThongKeCSKHActionTypes } from "../../action-types/thong-ke/IThongKeCSKHActions";
import { IThongKeCSKHReducer } from "../../page-state-model/thong-ke/IThongKeCSKHReducer";
const iniState: IThongKeCSKHReducer = {
    data: [],
    status: ePageBaseStatus.is_not_initialization,
    dataByMonth: [],
    statusByMonth: ePageBaseStatus.is_not_initialization
}
export const thongKeCSKHReducer = (
    state: IThongKeCSKHReducer = iniState,
    action: IThongKeCSKHActionTypes
): IThongKeCSKHReducer => {
    switch (action.type) {

        case "THONG_KE_CSKH_LOAD_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case "THONG_KE_CSKH_LOAD_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                data: action.payload
            }
        case "THONG_KE_CSKH_LOAD_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        case "THONG_KE_CSKH_LOAD_BY_MONTH_START":
            return {
                ...state,
                statusByMonth: ePageBaseStatus.is_loading
            }
        case "THONG_KE_CSKH_LOAD_BY_MONTH_SUCCESS":
            return {
                ...state,
                statusByMonth: ePageBaseStatus.is_completed,
                dataByMonth: action.payload
            }
        case "THONG_KE_CSKH_LOAD_BY_MONTH_ERROR":
            return {
                ...state,
                statusByMonth: ePageBaseStatus.is_completed,
            }
        default:
            return state;
    }
}